import requests from "./httpService";

const ProjectServices = {
  getAllProjects(companyId) {
    return requests.get(`/projects?company_id=${companyId}`);
  },
  getProjectsList(companyId) {
    return requests.get(`/projects/list?company_id=${companyId}`);
  },
  createProject(body) {
    return requests.post(`/projects/create`, body);
  },
  updateProject(id, body) {
    return requests.post(`/projects/update/${id}`, body);
  },
  deleteProject(id) {
    return requests.delete(`/projects/delete/${id}`);
  },
  getProjectDetail(id) {
    return requests.get(`/projects/detail/${id}`);
  },
  uploadAttachment(projectId, formData, headers) {
    return requests.post(`/projects/attachments/${projectId}`, formData, headers);
  },
  deleteAttachment(attachmentId) {
    return requests.post(`/projects/attachmentdelete/${attachmentId}`);
  }
};

export default ProjectServices;
